import React, { FC, useEffect, useState } from "react";
import Logo from "../../Assets/Logo2.svg";
import { resetAppState } from "../../State/store";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../Components/ui/dropdown-menu";
import { Avatar, AvatarFallback, AvatarImage } from "../../Components/ui/avatar";
import { User, LogOut, CircleArrowLeft } from "lucide-react";
import { CaretSortIcon } from "@radix-ui/react-icons";
import { useNavigate } from "react-router-dom";
import { setWorkspaceId, setisAuthstate, setworkspace } from "../../State/slices/AuthenticationSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { RootState } from "../../State/store";
import axios from "axios";


interface DropdownMenuDemoProps {
  profileImage: string;
  profileName: string;
  setAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
}

interface Workspace {
  workspace_id: number;
  workspace_name: string;
}

interface WorkspaceDialogProps {
  open: boolean;
  handleClose: () => void;
  setAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
}


// DropdownMenuDemo component
export function DropdownMenuDemo({
  profileImage,
  profileName,
  setAuthenticated,
}: DropdownMenuDemoProps) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [workspaceList, setWorkspaceList] = useState<Workspace[]>([]);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const email = useSelector((state: RootState) => state.authentication.userEmail);
  const apiUrl = useSelector((state: RootState) => state.authentication.apiURL);
  const mdSize = "text-[14px]";
  const closeAddWorkspaceDialog = useSelector((state: RootState) => state.advertiserAccount.closeAddWorkspaceDialog);
  const apiUrlAdvAcc = useSelector((state: RootState) => state.authentication.apiURL);
  const admin_workspace_id = useSelector((state: RootState) => state.authentication.workspace_id);
  const CurrentAID = useSelector((state: RootState) => state.authentication.account_id);

  useEffect(() => {
    // seturl();
    try {
      const GetMultipleWorkspacesByEmail = async () => {
        const response = await axios.get(
          `${apiUrl}/GetMultipleWorkspacesByEmail?EmailId=` + email
        );
        if (response.data.status == "Success") {
          console.log(response.data.workspaceList);
          setWorkspaceList(response.data.workspaceList);
        }
      };
      GetMultipleWorkspacesByEmail();
    }
    catch (error) {
      console.error("Network error: ", error);
    }

  }, []);

  const clearAllCookies = () => {
    document.cookie.split(";").forEach((cookie) => {
      const [name] = cookie.split("=");
      document.cookie = `${name.trim()}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });
    console.log("All cookies cleared!");
  };

  const insertAudit = async (auditDto: any, apiUrlAdvAcc: string) => {
    try {
      await axios.post(`${apiUrlAdvAcc}/InsertOverAllAuditHistory`, auditDto);
      console.log("Audit inserted successfully");
    } catch (error) {
      console.error("Failed to insert audit:", error);
    }
  };


  const backToWorkspace = async () => {
    try {
      const response = await axios.post(`${apiUrl}/GetWorkspaceDetailsByEmail`, { email: email });
      debugger
      if (response.data[0].Status == "Success") {
        dispatch(setworkspace(response.data[0].Workspace_Name));
        dispatch(setWorkspaceId(Number(response.data[0].WorkspaceId)));
      }
      else {
        console.error("sending user to adv workspace failed");
      }
    }
    catch (error) {
      console.error("sending user to adv workspace failed: ", error);
    }
  }

  useEffect(() => {
    if (closeAddWorkspaceDialog) {
      handleClose();
    }
  }, [closeAddWorkspaceDialog])


  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>

          <div className="flex w-full ml-4 text-left items-center text-gray-500 hover:text-black rounded-lg cursor-pointer">
            <img
              src={Logo}
              alt="Logo"
              style={{ width: "85px", height: "16.512px" }}
            />
            <div className="w-4 h-4">
              <CaretSortIcon className="ml-6" style={{ color: '#020617' }} />
            </div>
          </div>

        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-56 mt-4 -ml-4">
          <DropdownMenuGroup>
            <DropdownMenuItem
              onClick={() => {
                if (workspaceList.length > 0) {
                  // Get the saved workspace ID from session storage
                  const savedWorkspaceId = sessionStorage.getItem("selectedWorkspaceId");

                  if (savedWorkspaceId) {
                    // Find the workspace with the saved ID
                    const savedWorkspace = workspaceList.find(
                      workspace => workspace.workspace_id.toString() === savedWorkspaceId
                    );

                    if (savedWorkspace) {
                      // Set the previously selected workspace
                      dispatch(setworkspace(savedWorkspace.workspace_name));
                      dispatch(setWorkspaceId(savedWorkspace.workspace_id));
                    } else {
                      // Fallback to first workspace if saved workspace not found
                      const firstWorkspace = workspaceList[0];
                      dispatch(setworkspace(firstWorkspace.workspace_name));
                      dispatch(setWorkspaceId(firstWorkspace.workspace_id));
                    }
                  } else {
                    // No saved workspace ID, use the first one
                    const firstWorkspace = workspaceList[0];
                    dispatch(setworkspace(firstWorkspace.workspace_name));
                    dispatch(setWorkspaceId(firstWorkspace.workspace_id));
                  }
                }
                navigate("/navbar/dashboard", {
                  state: { path: profileName, route: "Dashboard" },
                });
              }}
              className="cursor-pointer"
            >
              <CircleArrowLeft className="mr-2 h-4 w-4" />
              <span className="text-[14px] text-[#020617] font-normal">
                My Workspace
              </span>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </DropdownMenuGroup>

          <DropdownMenuGroup>

          </DropdownMenuGroup>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            className="mb-1 cursor-pointer"
            onClick={async () => {
              const auditDto = {
                UserAccountId: CurrentAID || null,
                CampaignId: 0,
                AdvertiserWorkspaceId: null,
                Action: "Admin Logout",
                ActionPage: "Admin Dropdown",
                Status: "Success",
                AfterData: JSON.stringify({ message: "User logged out successfully" }),
                Comments: "User initiated logout",
              };

              await insertAudit(auditDto, apiUrlAdvAcc);
              clearAllCookies();
              resetAppState(); // Reset Redux state and purge persistor
              sessionStorage.removeItem("persist:root"); // Remove persisted data
              sessionStorage.clear();
              localStorage.clear();
              setAuthenticated(false);
              dispatch(setisAuthstate(false));
              navigate("/");
            }}

          >
            <LogOut className="mr-2 h-4 w-4" />
            <span className="text-[14px] text-[#020617] font-normal">
              Log out
            </span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
